require('./bootstrap');
require('./bwpublisher');

import ScrollReveal from 'scrollreveal';

$(function () {
    // CSRF Token for AJAX Calls
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': document.head.querySelector('meta[name="csrf-token"]').content
        }
    });

    // Mobile menu toggle
    $('.toggle-nav').on('click', function () {
        $('.toggle-nav, header nav, .logo').toggleClass('active');
    });

    // Show current page in nav
    if (window.location.pathname !== '/') {
        $('header a[href^="' + window.location.origin + window.location.pathname + '"]').addClass('active');
    }

    // Toggle header class based on scroll
    var headerH = $('header').outerHeight();

    $(window).on('scroll', function () {
        let currentPos = Math.round($(window).scrollTop());

        if (currentPos > headerH) {
            $('header').addClass('pinned');
        } else {
            $('header').removeClass('pinned');
        }
    }).trigger('scroll');

    // Smooth scrolling
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            let $tar = document.querySelector(this.getAttribute('href'));

            if ($tar) {
                $tar.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        });
    });

    // Show Modal
    $('[href^="#show-modal-"]').on('click', function (e) {
      e.preventDefault();

      let $tar = $(this).attr('href').replace(/show-modal-/g, '');

      showModal($tar);
    });

    // Show Gallery
    $('[href^="#show-gallery-"]').on('click', function (e) {
      e.preventDefault();

      let $tar = $(this).attr('href').replace(/show-gallery-/g, '');

    //   showGallery($tar);
    });

    window.sr = ScrollReveal();
    sr.reveal('.content-block, .gallery-container img', {
        duration: 1500,
        reset: true,
        scale: 1
    });

    //

    $('.loader').fadeOut('slow');
});

$('#slider-content').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    cssEase: 'linear',
    autoplay: false,
    responsive: [{
        breakpoint: 768,
        settings: {
            arrows: false
        }
    }]
});

// Enquiry
$('.show-enquiry-form').on('click', function (e) {
    e.preventDefault();

    if ($('.toggle-nav.active').length) {
        $('.toggle-nav').trigger('click');
    }

    $('#enquiry')[0].scrollIntoView({
        behavior: 'smooth'
    });
});

// Convert .svg image to SVG format (add class="svg")
$('img.svg').each(function() {
    var $img = $(this);
    var imgID = $img.attr('id');
    var imgClass = $img.attr('class');
    var imgURL = $img.attr('src');

    $.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = $(data).find('svg');

        // Add replaced image's ID to the new SVG
        if (typeof imgID !== 'undefined') {
            $svg = $svg.attr('id', imgID);
        }

        // Add replaced image's classes to the new SVG
        if (typeof imgClass !== 'undefined') {
            $svg = $svg.attr('class', imgClass + ' replaced-svg');
        }

        // Remove any invalid XML tags as per http://validator.w3.org
        $svg = $svg.removeAttr('xmlns:a');

        // Replace image with new SVG
        $img.replaceWith($svg);
    }, 'xml');
});

$(function () {
    var $enquiryForm = $('#enquiry-form');

    if ($enquiryForm.find('.error:not(:empty)').length) {
        $enquiryForm[0].scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }

    $enquiryForm.validate({
        rules: {
            'event_type': {
                require_from_group: [1, '.event-type'],
            }
        },
        errorElement: 'span',
        errorPlacement: function (error, element) {
            if (element.is(':radio')) {
                error.insertAfter(element.closest('.event-type-container'));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            if (grecaptcha.getResponse()) {
                form.submit();
            } else {
                grecaptcha.reset();
                grecaptcha.execute();
            }
        }
    });

    function recaptchaCallback() {
        $enquiryForm.trigger('submit');
    }
});

$('#subscribe-form').validate({
    errorElement: 'span',
    rules: {
        'cm-sduhur-sduhur': {
            required: true,
            email: true
        }
    },
    errorPlacement: function(error, element) {
        error.insertAfter(element.parent());
    }
});
